import React from 'react';
import Chart from 'react-apexcharts';

class WidgetBarGraph extends React.Component {

  render() {
    const table = this.props.table;
    const options = {
      title: {
        text: this.props.name,
        align: 'middle'
      },
      xaxis: {
        categories: []
      },
      chart: {
        events: {
          dataPointSelection: (_, __, config) => {
            console.log(config.dataPointIndex);
          }
        }
      }
    };
    const series = [{
      name: this.props.name,
      data: []
    }];

    for(let i = 1; i < table.length - 1; i++) {
      options.xaxis.categories.push(table[i][0]);
      series[0].data.push(table[i][1]);
    }
    
    return(
      <div className={`col-md-${this.props.report ? 12 : 4}`}>
        <Chart options={options} series={series} type="bar" height={320} />
      </div>
    );
  }
}
export default WidgetBarGraph;